import React, { useEffect, useState } from 'react';
import { useMyContentContext } from '../../../../utils/myContentContext';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faInfo, faPenToSquare, faPlus, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import NoAssignment from '../../../../../../assets/images/NoAssignment.png';
import { questionTypes } from '../../../../utils/contants';
import {
  useDeleteQuestionMutation,
  useGetQuestionPreviewMutation,
  useGetQSetDetailsMutation,
  useMoveQsetQuestionMutation,
  useDuplicateCLOQuestionForEditMutation,
} from '../../../../../../features/authentication/qSetApiSlice';
import QuestionDetail from '../../../../../assignments/components/QuestionDetail';
import QuestionPreviewTypes from '../../../../../../enums/questionPreviewTypes';
import AssignmentsUsedBy from '../../../../../questionsSearch/components/AssignmentsUsedBy';
import CustomToast from '../../../../../../components/Toast';
import QuestionTypes from '../../../../../../enums/questionTypes';
import ConfirmationModal from '../../../../../../components/ConfirmationPopUp';
import SkeletonGrid from '../../../../../../components/SkeletonLoader/SkeletonGrid';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DropDown from '../../../../../../../src/components/DropDown/index';
import { languages } from '../../../../utils/contants';

const AddQuestionsIndex = () => {

  const {
    questionSetName,
    setQuestionSetName,
    setQuestionSetId,
    setDateTimeBasedUniqueKey,
    resetContext
  } = useMyContentContext();

  const navigate = useNavigate();
  const { setId } = useParams();
  const [getQsetDetails] = useGetQSetDetailsMutation();
  const [getQuestionPreview] = useGetQuestionPreviewMutation();
  const [deleteQuestion] = useDeleteQuestionMutation();
  const [moveQuestion] = useMoveQsetQuestionMutation();
  const [duplicateCLOQuestion] = useDuplicateCLOQuestionForEditMutation();
  const [qSetQuestions, setQsetQuestions] = useState(null);
  const [openedQuestion, setOpenedQuestion] = useState(0);
  const [questionPreview, setQuestionPreview] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [assignmentsUsed, setAssignmentsUsed] = useState([]);
  const [openDeleteConfirmModel, setOpenDeleteConfirmModel] = useState(false);
  const [deleteQuestionId, setDeleteQuestionId] = useState(0);
  const [openConfirmEditModel, setOpenConfirmEditModel] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [editWarning, setEditWarning] = useState('');
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [editQuestion, setEditQuestion] = useState({});
  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(0);

  const manageClick = (qType) => {
    resetContext();
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
    const pathParts = qType.path.split('/');
    const lastSegment = pathParts.pop();
    navigate(`${pathParts.join('/')}/${setId}/${lastSegment}`);
  };

  useEffect(() => {
    getQsetQuestionsAsync();
  }, []);

  const getQsetQuestionsAsync = async () => {
    setIsLoading(true);
    let options = {
      setId: setId
    };
    const response = await getQsetDetails(options).unwrap();
    setQuestionSetName(response.setName);
    setQuestionSetId(setId);
    const updatedQuestion = getQuestionColorCode(response.questions);
    const positionedDocs = updatedQuestion.map((item, index) => { return { ...item, position: index + 1 }; });
    setQsetQuestions(positionedDocs);
    setAllQuestions(positionedDocs);
    setIsLoading(false);
  };

  const getQuestionColorCode = (questions) => {
    const updatedArray = questions?.map((item) => {
      let questionItem = {};
      if (item.questionCourseId >= 0 || item.questionCourseId < -2)
        questionItem = { ...item, color: 'text-success' };
      else {
        if (item.isCloQuestion)
          questionItem = { ...item, color: 'text-color-yellow' };
        else
          questionItem = { ...item, color: '' };
      }

      if (item.questionCourseId >= 0) {
        if ((item.questionType == QuestionTypes.MC || item.questionType == QuestionTypes.CR || item.questionType == QuestionTypes.FillIn))
          return { ...questionItem, isCastleQuestion: true };
        else
          return { ...questionItem, isQuarantined: true };
      }
      else if (item.questionCourseId < -2)
        return { ...questionItem, isQuarantined: true };
      else
        return { ...questionItem };
    });
    return updatedArray;
  };

  const handleQuestionPreview = async (questionId, questionNo, languageId) => {
    setQuestionPreview({});
    setSelectedLanguage(languageId);
    if (openedQuestion === questionId)
      setOpenedQuestion(0);
    else
      getQuestionPreviewAsync(questionId,questionNo,languageId);
  };

  const handleLanguageChange = (questionId, questionNo, languageId) =>{
    if(languageId == selectedLanguage)
      return;
    else
    {
      setSelectedLanguage(languageId);
      getQuestionPreviewAsync(questionId,questionNo,languageId);
    }
  };

  const getQuestionPreviewAsync = async(questionId,questionNo,languageId) =>{
    setIsPreviewLoading(true);
    setOpenedQuestion(questionId);
    let option = {
      setId: setId,
      questionNo: questionNo,
      languageId:languageId
    };
    const response = await getQuestionPreview(option).unwrap();
    setQuestionPreview(response);
    setIsPreviewLoading(false);
  };

  const handleDelete = async (questionId) => {
    let option = {
      setId: setId,
      questionId: questionId
    };
    const response = await deleteQuestion(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      setQsetQuestions((prevQuestions) =>
        prevQuestions.filter((question) => question.questionId !== questionId)
      );
      CustomToast('Question deleted successfully', 'success');
      setOpenDeleteConfirmModel(false);
      setDeleteQuestionId(0);
    }
  };

  const getQuestionInfo = (courseId, type) => {
    if (courseId >= 0)
      if ((type == QuestionTypes.MC || type == QuestionTypes.CR || type == QuestionTypes.FillIn))
        return 'This is a Castle owned question. Note that once you create a new teacher copy of this question, the original Castle question will not be quarantined when this set is transferred to an administrator.';
      else
        return 'This type of Castle owned question cannot be edited. It will be quarantined when this set is transferred to an administrator.';
    else if (courseId < -2)
      return 'This is a Castle owned skill question that cannot be edited. It will be quarantined when this set is transferred to an administrator.';
    else
      return '';
  };

  const confirmEdit = async (editQuestion) => {
    if (editQuestion.isCastleQuestion)
    {
      setEditWarning('Please note: By editing this Castle question, you are creating a teacher copy of it.<br/>If this Castle question is already in an assignment, it will NOT be modified.<br/><br/>If you wish to modify this Castle question in your assignment, you will need to go to the assignment,<br/>remove the old question and add the new teacher copy.');
      setOpenConfirmEditModel(true);
    }
    else if(editQuestion.usedBy.length > 0)
    {
      setEditWarning('Please NOTE: This question is currently being used in an assigned assignment.<br/>By making modifications to this PCS question, you will be changing the question in the assigned assignment as well <br/>.Are you SURE you want to proceed?');
      setOpenConfirmEditModel(true);
    }
    else
      handleEdit(editQuestion);
    
  };

  const handleEdit = async (editQuestion) => {
    let newQuestionId = editQuestion.questionId;
    let courseId = editQuestion.questionCourseId;
    if (editQuestion.isCastleQuestion) {
      let option = {
        setId: setId,
        questionId: editQuestion.questionId,
        courseId: editQuestion.questionCourseId
      };
      const response = await duplicateCLOQuestion(option);
      if (response.error) {
        if (response.error.data.errors)
          CustomToast(response.error.data.errors.Description, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      } else if (response.data) {
        newQuestionId = response.data.newQuestionId;
        courseId = response.data.questionCourseId;
      }
    }
    if (editQuestion.questionType == QuestionTypes.CR)
      navigate(`/mycontent/questionsets/${setId}/cr_Question/${newQuestionId}/${courseId}`);
    else
      navigate(`/mycontent/questionsets/${setId}/mc_fillInQuestion/${newQuestionId}/${courseId}`);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(qSetQuestions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    if (result.source.index != result.destination.index) {
      updateDocumentPosition(parseInt(result.draggableId), result.source.index + 1, result.destination.index + 1);
      setQsetQuestions(items);
    }
  };

  const updateDocumentPosition = async (questionId, initialPosition, finalPosition) => {
    if (finalPosition > qSetQuestions.length)
      finalPosition = qSetQuestions.length;

    finalPosition = qSetQuestions[finalPosition - 1].position;
    initialPosition = qSetQuestions[initialPosition - 1].position;

    let updatedQuestions = qSetQuestions;
    if (initialPosition < finalPosition) {
      updatedQuestions = updatedQuestions.map(item => {
        if (item.position > initialPosition && item.position <= finalPosition) {
          return { ...item, position: item.position - 1 };
        }
        return item;
      });
    } else {
      updatedQuestions = updatedQuestions.map(item => {
        if (item.position >= finalPosition && item.position < initialPosition) {
          return { ...item, position: item.position + 1 };
        }
        return item;
      });
    }

    updatedQuestions = updatedQuestions.map(item => {
      if (item.position === initialPosition && item.questionId == questionId) {
        return { ...item, position: finalPosition };
      }
      return item;
    });
    updatedQuestions.sort((a, b) => a.position - b.position);
    moveQuestionAsync(updatedQuestions);
    setQsetQuestions(updatedQuestions);
  };

  const moveQuestionAsync = async (questions) => {
    const questionIds = questions.map((item) => item.sQuestionId);
    let option = {
      setId: setId,
      questionIds: questionIds
    };
    await moveQuestion(option).unwrap();
    CustomToast('Question moved successfully', 'success');
  };

  const handleSearch = (searchText) =>{
    const searchQuestions = allQuestions.filter((item)=>item.sQuestionId.toLowerCase().includes(searchText.toLowerCase()));
    setQsetQuestions(searchQuestions);
  };

  return (
    <div className="white-card">
      {!isLoading ? (
        <div id="reportWrapper">
          <div className="d-flex justify-content-between">
            <div className='d-flex'>
              <h1 className='mb-4'>{questionSetName}</h1>
            </div>
            <div id="buttonGroup" className="ReportToolbarBtn gap-3 align-items-center">
              <button id="back_button" onClick={() => navigate('/mycontent/questionsets')} className="btn btn-width btn-castleWhite">
                Back
              </button>
            </div>
          </div>
          <div className={`mb-0 m-0 my-4 ${allQuestions?.length == 0 && 'no-content-card'}`}>
            {allQuestions?.length == 0 &&
              <div className="text-center mb-4">
                <img src={NoAssignment} className='my-4' />
                <p>
                  Question Set is currently empty, use the <strong>Create/Add buttons</strong> to add Questions to the set.
                </p>
              </div>}
            <div className={`d-flex gap-2 ${allQuestions?.length == 0 && 'justify-content-center'}`}>
              {questionTypes.map((item) => (
                <div key={item.id}>
                  {qSetQuestions?.length >= 100 ? (
                    <OverlayTrigger
                      key="assignmentsUsed"
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">
                        {qSetQuestions?.length >= 100 && 'You have reached maximum number of 100 Questions per set.'}
                      </Tooltip>}>
                      <div>
                        <button
                          disabled={qSetQuestions?.length >= 100}
                          className={`p-2 btn-questionset text-start w-100 ${qSetQuestions?.length >= 100 ? 'disable-Pointer-Events' : ''}`}
                          onClick={() => manageClick(item)}
                        >
                          <div className='align-items-center d-flex'>
                            <div className='align-items-center blue-icon d-flex fs-5 justify-content-center'><FontAwesomeIcon icon={faPlus} /></div>
                            <p className='m-0'>{item.title}</p>
                          </div>
                        </button>
                      </div>
                    </OverlayTrigger>
                  ):(
                    <div>
                      <button
                        className='p-2 btn-questionset text-start w-100'
                        onClick={() => manageClick(item)}
                      >
                        <div className='align-items-center d-flex'>
                          <div className='align-items-center blue-icon d-flex fs-4'><FontAwesomeIcon icon={faPlus} /></div>
                          <p className='m-0'>{item.title}</p>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
            {allQuestions?.length > 0 &&
            <>
              <div className="custom-search position-relative mb-3 mt-4">
                <FontAwesomeIcon icon={faSearch} />
                <input type="text" placeholder='Search questions' className="form-control" onChange={(e)=>handleSearch(e.target.value)}/>
              </div>
              <div className="w-100 mt-4 mb-4 info-text d-flex align-items-center">
                <span className="flex-shrink-0">
                  <FontAwesomeIcon icon={faInfo} />
                </span>
                <p>Questions in <label className='text-success fw-semibold'>Green</label> are Castle owned questions, <label className='text-color-yellow fw-semibold'>Yellow</label> are teacher edited and owned Castle questions and <strong>Black</strong> are teacher created and owned questions.
                </p>
              </div>
            </>
            }
            <div onMouseEnter={() => setIsMouseOver(false)} onMouseLeave={() => setIsMouseOver(true)}>
              {qSetQuestions?.length > 0 &&
                <>
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId='rows'>
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {qSetQuestions.map((question, index) => (
                            <Draggable key={question.questionId} draggableId={`${question.questionId}`} index={index}>
                              {(provided, snapshot) => (
                                <div key={'castleRes' + index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                  className={`mt-3 border-grey ${snapshot.isDragging && 'drag-style'} ${(isMouseOver && snapshot.isDragging) && ' cursor-not-allowed'}`}>
                                  <div key={index} className='w-100'>
                                    <div className="justify-content-between align-items-center">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <h6
                                          className={question.color}
                                        >{`Question ${index + 1} (ID = ${question.sQuestionId})`}</h6>
                                        <div>
                                          <button className={'btn btn-castleRed mr-2 h-50'} disabled={question.isQuarantined || question.isCastleQuestion || question.usedBy.length == 0} onClick={() => { setAssignmentsUsed(question.usedBy); setShowUsedByModal(true); }}>Assignments Using</button>
                                          <OverlayTrigger
                                            key="assignmentsUsed"
                                            placement="top"
                                            overlay={<Tooltip className="custom-tooltip">
                                              {question.isQuarantined ? 'Cannot be edited. It will be quarantined when this set is transferred to an administrator.' : question.isCastleQuestion ? 'Duplicate and Edit' : 'Edit'}
                                            </Tooltip>}>
                                            <button
                                              className={'btn grid-icon-btn info-icon-btn mr-2'} disabled={question.isQuarantined} onClick={() => {confirmEdit(question);setEditQuestion(question);}}>
                                              <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            key="deleteQuestion"
                                            placement="top"
                                            overlay={<Tooltip className="custom-tooltip">Delete</Tooltip>}>
                                            <button className="btn grid-icon-btn danger-icon-btn mr-2" onClick={() => { setDeleteQuestionId(question.questionId); setOpenDeleteConfirmModel(true); }}>
                                              <FontAwesomeIcon icon={faTrashAlt} />
                                            </button>
                                          </OverlayTrigger>
                                          <button
                                            onClick={() => handleQuestionPreview(question.questionId, index + 1, 0)}
                                            className={`rounded-circle chevron-icon z-index10 ${question.questionId === openedQuestion && 'set-open'}`}>
                                            <FontAwesomeIcon icon={faChevronRight} />
                                          </button>
                                        </div>
                                      </div>

                                      <div className={`toggleDive ${!(question.questionId == openedQuestion) && 'd-none'}`}>
                                        <div className='w-100 mt-4 mb-4 line'></div>
                                        <div className='text-danger mb-4 fw-bold'>{getQuestionInfo(question.questionCourseId, question.questionType)}</div>
                                        <Row>
                                          <Col className='col-10'></Col>
                                          <Col className='col-2 mb-4'>
                                            <DropDown
                                              value={languages}
                                              selectedValue={selectedLanguage}
                                              description={true}
                                              onChangeHandler={(e) => handleLanguageChange(question.questionId, index + 1, e.target.value)}
                                            />
                                          </Col>
                                        </Row>
                                        <p>
                                          <QuestionDetail
                                            isLoading={isPreviewLoading}
                                            questionDetails={questionPreview}
                                            type={QuestionPreviewTypes.assignmentPreview}
                                            isPublicAssignment={false}
                                            isFromQset={true}
                                            assignmentId={-1}
                                            selectedLanguage={parseInt(selectedLanguage)}
                                          />
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </>}
            </div>
          </div>
          <ConfirmationModal
            isOpen={openDeleteConfirmModel}
            onClose={() => setOpenDeleteConfirmModel(false)}
            titleName='Delete Question'
            onSave={() => handleDelete(deleteQuestionId)}
            cancelButton='No'
            confirmButton='Yes'
            contentWidth='35%'
            buttonPosition='center'
            content='Deleting this question is permanent. There is no way to restore it. Are you sure you want to delete it?'
          />
          <ConfirmationModal
            isOpen={openConfirmEditModel}
            onClose={() => setOpenConfirmEditModel(false)}
            titleName={`Question ${editQuestion.sQuestionId} is Assigned`}
            onSave={() => handleEdit(editQuestion)}
            cancelButton='Cancel'
            confirmButton='Yes'
            contentWidth='50%'
            buttonPosition='center'
            content={editWarning}
          />
          <AssignmentsUsedBy
            usedAssignments={assignmentsUsed}
            showUsedByModal={showUsedByModal}
            setShowUsedByModal={setShowUsedByModal}
          />
        </div>
      ) : (
        <>
          <SkeletonGrid
            rowCount={3}
            colCount={1}
            className='p-1 mt-4'
          />
          <SkeletonGrid
            rowCount={3}
            colCount={1}
            className='p-5 mt-4'
          />
        </>
      )}

    </div>
  );
};

export default AddQuestionsIndex;
